import React, {useContext, useEffect, useState} from 'react'
import TablaDinamica from '../TablaDinamica'
import {
  EncabezadoFondo,
  CeldaTextoConBoton,
  CeldaTextoEstilosEditables,
  CeldaFormatoDinero,
} from '../Tablas'
import {
  ObtenerMovimientosPaginadosPorEmpresaId,
  GenerarDocumentoFactura,
} from '../../microservicios'
import {useMsal} from '@azure/msal-react'
import {useNavigate} from 'react-router-dom'
import {BotonConImagen} from '../Botones'
import moment from 'moment'
import IconoVisualizar from '../../imagenes/iconoVisualizar.svg'
import IconoDescargar from '../../imagenes/botonDescargar.svg'
import {TIPOS_MOVIMIENTO, TIPO_DOCUMENTO} from '../../constantes'
import SolicitarExportarMovimientos from '../Botones/SolicitarExportarMovimientos'
import {CrearSolicitudReporte} from '../../microservicios/GatoApi'
import {ContextoAplicacion} from '../../contexto'
import {PaginacionConBackend} from '../Tablas'
import {useFeatureIsOn} from '@growthbook/growthbook-react'
import {TEXTO_FEATURE_FLAGS} from '../../constantes/featureFlags'

const TablaMovimientosYDetalles = ({activarPaginacionFront}) => {
  const navigate = useNavigate()

  const {accounts} = useMsal()
  const contextoAplicacion = useContext(ContextoAplicacion)
  const idEmpresa = contextoAplicacion.infoEmpresa.id ?? 0

  const [datos, setDatos] = useState([])

  const [informacionPaginacion, setInformacionPaginacion] = useState({})

  const [numeroPagina, setNumeroPagina] = useState(1)

  const featActivarGenerarReporteDelMovimiento = useFeatureIsOn(
    TEXTO_FEATURE_FLAGS.ACTIVAR_GENERAR_REPORTE_DEL_MOVIMIENTO
  )

  useEffect(() => {
    const ObtenerDatosCuenta = async (
      numeroPagina = 1,
      cantidadPaginas = 10
    ) => {
      try {
        const response = await ObtenerMovimientosPaginadosPorEmpresaId(
          idEmpresa,
          cantidadPaginas,
          numeroPagina
        )
        if (response.status === 204) {
          return
        }

        setInformacionPaginacion(response.data.paginacion)
        const datosPromesas = response.data.datos.map(async (elemento) => {
          return {
            fecha: moment(elemento.fecha).format('DD/MM/YYYY'),
            documentoContable: elemento.documentoContable,
            urlDocumentoContable: elemento.urlDocumentoContable,
            valor: elemento.valor,
            tipoMovimiento: elemento.tipoMovimiento,
            detalle: elemento.detalle,
            atencionId: elemento.atencionId ? elemento.atencionId : '',
            urlReciboCaja: elemento.urlReciboCaja,
            id: elemento.id,
            facturaId: elemento.facturaId,
            tipoDocumentoContableId: elemento.tipoDocumentoContableId,
          }
        })

        const datos = await Promise.all(datosPromesas)
        setDatos(datos)
      } catch (error) {
        console.error(error)
      }
    }
    if (idEmpresa) {
      ObtenerDatosCuenta(numeroPagina)
    }
  }, [idEmpresa, numeroPagina])

  const verResultadoPaciente = (id) => {
    navigate('/resultadospaciente', {state: {state: {atencionId: id}}})
  }

  const abrirDocumento = (urlDocumento) => {
    if (urlDocumento) {
      var win = window.open(urlDocumento, '_blank')
      win.focus()
    }
  }

  const generarDocumento = async (facturaId) => {
    const documento = await await GenerarDocumentoFactura({facturaId})
    abrirDocumento(documento.data)
  }

  const columns = React.useMemo(() => [
    {
      Header: () => (
        <EncabezadoFondo
          titulo={'FECHA'}
          estilosEncabezado={'bg-white text-cendiatra font-bold text-17px'}
        />
      ),
      accessor: 'fecha',
      className: 'w-2/12',
    },
    {
      Header: () => (
        <EncabezadoFondo
          titulo={'N° DOCUMENTO CONTABLE'}
          estilosEncabezado={'bg-white text-cendiatra font-bold text-17px'}
        />
      ),
      accessor: 'documentoContable',
      className: 'w-2/12',
    },
    {
      accessor: 'urlDocumentoContable',
      className: 'w-10 ml-2',
      Cell: (row) =>
        row.row.original.tipoDocumentoContableId ===
          TIPO_DOCUMENTO.NOTA_CREDITO ||
        (!row.row.original.facturaId &&
          !row.row.original.urlDocumentoContable) ? null : (
          <BotonConImagen
            funcionAEjecutar={() => {
              row.row.original.urlDocumentoContable
                ? abrirDocumento(row.row.original.urlDocumentoContable)
                : generarDocumento(row.row.original.facturaId)
            }}
            estilos="w-full flex justify-center items-center"
            imagen={IconoDescargar}
          />
        ),
    },
    {
      Header: () => (
        <EncabezadoFondo
          titulo={'VALOR'}
          estilosEncabezado={'bg-white text-cendiatra font-bold text-17px'}
        />
      ),
      accessor: 'valor',
      className: 'w-3/12',
      Cell: (row) => (
        <CeldaFormatoDinero
          estilos={` font-bold flex justify-center items-center text-center pointer-events-none ${
            row.row.original.tipoMovimiento === 2
              ? 'text-cendiatra-rojo-1 '
              : 'text-cendiatra'
          }`}
          valor={row.row.original.valor}
        />
      ),
    },
    {
      Header: () => (
        <EncabezadoFondo
          titulo={'DETALLE'}
          estilosEncabezado={'bg-white text-cendiatra font-bold text-17px'}
        />
      ),
      accessor: 'detalle',
      className: 'w-3/12',
      Cell: (row) => (
        <CeldaTextoEstilosEditables
          texto={row?.row?.original?.detalle}
          estilos={'w-full flex justify-center items-center'}
          imagen={IconoDescargar}
        />
      ),
    },
    {
      Header: () => (
        <EncabezadoFondo
          titulo={'NÚMERO DE ATENCIÓN'}
          estilosEncabezado={'bg-white text-cendiatra font-bold text-17px'}
        />
      ),
      accessor: 'atencionId',
      className: 'w-2/12',
      Cell: (row) => (
        <CeldaTextoConBoton
          texto={row.row.original.atencionId}
          mostrarImagen={
            row.row.original.tipoMovimiento === TIPOS_MOVIMIENTO.DESCUENTO &&
            row.row.original.atencionId
          }
          funcion={() => verResultadoPaciente(row.row.original.atencionId)}
          estilos={'w-full flex justify-center items-center'}
          imagen={IconoVisualizar}
        />
      ),
    },
  ])

  const exportarDatos = async (datos) => {
    const payload = {
      nombreReporte: 'detalle_de_movimiento_de_cuenta',
      correoSolicitante: datos.correo,
      nombreSolicitante: accounts[0]?.name,
      Parametros: {
        sedeId: null,
        empresaId: idEmpresa,
        fechaDesde: datos.fechaInicial,
        fechaHasta: datos.fechaFinal,
        ParametrosAdicionales: null,
      },
    }

    try {
      await CrearSolicitudReporte(payload)
      contextoAplicacion.setModal({
        abierto: true,
        titulo: 'EL DOCUMENTO SE ENVIARÁ AL CORREO ELECTRÓNICO',
        contenido: (
          <>
            <div className="text-center w-full">
              <p className="text-cendiatra text-xl">
                La generación de este documento puede tomar un tiempo, por favor
                revise su bandeja de entrada
              </p>
            </div>
          </>
        ),
        botones: [
          {
            nombre: 'Regresar',
            click: () =>
              contextoAplicacion.setModal({
                abierto: false,
                titulo: '',
                contenido: '',
                botones: [],
              }),
          },
        ],
      })
    } catch (error) {
      console.log(error)
    }
  }

  const actualizarPagina = (paginaSeleccionada) => {
    setNumeroPagina(paginaSeleccionada)
  }

  return (
    <>
      <div className="w-full flex flex-wrap justify-center items-center">
        <TablaDinamica
          columns={columns}
          data={datos}
          fondoTabla={'bg-white'}
          bordeInferior={''}
          paginacion={activarPaginacionFront}
        />
        {!activarPaginacionFront ? (
          <PaginacionConBackend
            totalPaginas={informacionPaginacion?.totalPaginas}
            paginaActual={informacionPaginacion?.paginaActual}
            funcionIrAPagina={(e) => actualizarPagina(e)}
            maximoDePaginasparaMostrar={10}
          />
        ) : null}
      </div>
      <div className="w-full flex justify-end items-center">
        {datos.length && featActivarGenerarReporteDelMovimiento ? (
          <div className="w-auto flex justify-center items-center -mt-20">
            <SolicitarExportarMovimientos
              texto={'Generar Reporte Del Movimiento'}
              exportarDatos={exportarDatos}
            />
          </div>
        ) : null}
      </div>
    </>
  )
}

export default TablaMovimientosYDetalles
